import React, { useEffect, useState, useRef } from 'react';
import QRCode from 'qrcode.react';
import { formatCurrentDate, formatIndianCurrency, saveLogEvent } from '../../utils/Utils';
import { useNavigate, useParams } from 'react-router-dom';
import { voiceStore } from '../../stores/voiceStore';
import { observer } from 'mobx-react-lite';

const headers = {
    headers: {
        'clientId': 'CustomerFacingService',
        'environment': 'dev',
        'X-API-KEY': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
    }
}

const Confirmations = ({ customerInfo, inputValue, paymentId, thumbnail, labels, gpName, gpNumber, totalAmount ,customerThumbnails}) => {
    const { customerNumber, groupNumber ,selectedCustomers} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [refId, setRefId] = useState(null);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [paymentFailure, setPaymentFailure] = useState(false);
    const [payAmount, setPayerAmount] = useState(null);
    const [bankRRN, setBankRRN] = useState(null);
    const navigate = useNavigate();
    const isMountedRef = useRef(true);
    const storedCustomerId = sessionStorage.getItem("SvastiUserID");
    const customerId = JSON.parse(storedCustomerId);

    const url = `http://de.svasti.in/upilink.php?demandid=${paymentId.DemandId}`;

    useEffect(() => {
        isMountedRef.current = true; // Set as mounted

        return () => {
            isMountedRef.current = false; // Cleanup when unmounted
        };
    }, []);


    const redirectToPaymentPage = () => {
        const logMessage = groupNumber
            ? {
                trigger: "Group Pay dues page On click of button Pay from my phone",
                Page: "PaymentPage - Group Pay dues page",
                groupNumber,
                amount: totalAmount
            }
            : {
                trigger: customerNumber === customerId
                    ? "Paying Own Dues - On click of button Pay from my phone"  // ✅ For own dues
                    : "Pay to Other Member dues - On click of button Pay from my phone",  // ✅ For other members
                Page: customerNumber === customerId
                    ? "PaymentPage - Pay Own Dues"  // ✅ Page changes for own dues
                    : "PaymentPage - Pay to Other Member dues",  // ✅ Page remains the same for others
                paidCustomerNumber: customerNumber,
                amount: inputValue
            };
        // Log the event
        saveLogEvent({
            logLevel: "info",
            statusCode: 200,
            status: "success",
            source: "MCRO",
            message: {
                ...logMessage
            },
            payload: {
                demandId: paymentId?.DemandId || "N/A",
                trigger: logMessage.trigger,
                Page: logMessage.Page,
            },
        });
        window.open(url, '_blank');
    };

    const copyUrlToClipboard = () => {
        const logMessage = groupNumber
            ? {
                trigger: "Group Pay dues page On click of button Copy and share link for payment",
                Page: "PaymentPage - Group Pay dues page",
                groupNumber,
                amount: totalAmount
            }
            : {
                trigger: customerNumber === customerId
                    ? "Paying Own Dues - On click of button Copy and share link for payment"  // ✅ For own dues
                    : "Pay to Other Member dues - On click of button Copy and share link for payment",  // ✅ For other members
                Page: customerNumber === customerId
                    ? "PaymentPage - Pay Own Dues"  // ✅ Page changes for own dues
                    : "PaymentPage - Pay to Other Member dues",  // ✅ Page remains the same for others
                paidCustomerNumber: customerNumber,
                amount: inputValue
            };
        // Log the event
        saveLogEvent({
            logLevel: "info",
            statusCode: 200,
            status: "success",
            source: "MCRO",
            message: {
                ...logMessage
            },
            payload: {
                demandId: paymentId?.DemandId || "N/A",
                trigger: logMessage.trigger,
                Page: logMessage.Page,
            },
        });
        navigator.clipboard.writeText(url)
            .then(() => alert(labels.urlCopied))
            .catch((error) => console.error(labels.errorCopyingUrl, error));
    };

    useEffect(() => {
        let isMounted = true;
        const checkRefId = async () => {
            try {
                const response = await fetch(`https://microservices.svasti.in/CustomerFacingService/check-refid-status?demandid=${paymentId.DemandId}`, {
                    ...headers
                });
                if (!isMounted) return;
                const data = await response.json();

                if (data.RefIdGenerated === "Yes") {
                    setRefId(data.refId);
                    setIsLoading(false);
                    voiceStore.setVoiceCommand(paymentId.VoiceCommand3)
                    checkPaymentStatus();
                } else {
                    throw new Error(labels.refIdNotGenerated);
                }
            } catch (error) {
                if (isMounted) {
                    setTimeout(checkRefId, 2000);
                }
            }
        };

        checkRefId();
        return () => {
            isMounted = false;
        };

    }, [paymentId.DemandId, labels.refIdNotGenerated]);

    const checkPaymentStatus = async () => {
        if (!isMountedRef.current) return;
        try {
            const response = await fetch(`https://microservices.svasti.in/CustomerFacingService/DemandPaymentStatus`, {
                method: 'POST',
                ...headers
                ,
                body: JSON.stringify({
                    data: [
                        {
                            "demandId": paymentId.DemandId,
                        }
                    ]
                })
            });
            const data = await response.json();
            if (data.success) {
                if (data.data[0].TxnStatus === "SUCCESS") {
                    voiceStore.setVoiceCommand(data.data[0].voicecommand5)
                    setPaymentSuccessful(true);
                    setPayerAmount(data.data[0].PayerAmount);
                    setBankRRN(data.data[0].BankRRN)

                    const logMessage = groupNumber
                        ? {
                            trigger: "Group Pay dues After successful completion of payment",
                            Page: "PaymentPage - Group Pay dues page",
                            groupNumber,
                            amount: totalAmount
                        }
                        : {
                            trigger: customerNumber === customerId
                                ? "Paying Own Dues After successful completion of payment"  // ✅ For own dues
                                : "Pay to Other Member dues After successful completion of payment",  // ✅ For other members
                            Page: customerNumber === customerId
                                ? "PaymentPage - Pay Own Dues"  // ✅ Page changes for own dues
                                : "PaymentPage - Pay to Other Member dues",  // ✅ Page remains the same for others
                            paidCustomerNumber: customerNumber,
                            amount: inputValue
                        };


                    saveLogEvent({
                        logLevel: "info",
                        statusCode: 200,
                        status: "success",
                        message: {
                            customerNumber: customerId,
                            bankRRN: data.data[0].BankRRN,
                            amount: data.data[0].PayerAmount,
                            ...logMessage,
                            TxnStatus: "Success",
                        },
                        payload: {
                            trigger: logMessage.trigger,
                            Page: logMessage.Page,
                        }
                    });
                }
                if (data.data[0].TxnStatus === "FAILURE") {
                    voiceStore.setVoiceCommand(data.data[0].voicecommand6)
                    setPaymentFailure(true);
                    const logMessage = groupNumber
                        ? {
                            trigger: "Group Pay dues After failure to complete payment",
                            Page: "PaymentPage - Group Pay dues page",
                            groupNumber,
                            amount: totalAmount
                        }
                        : {
                            trigger: customerNumber === customerId
                                ? "Paying Own Dues After failure to complete paymentt"  // ✅ For own dues
                                : "Pay to Other Member dues After failure to complete payment",  // ✅ For other members
                            Page: customerNumber === customerId
                                ? "PaymentPage - Pay Own Dues"  // ✅ Page changes for own dues
                                : "PaymentPage - Pay to Other Member dues",  // ✅ Page remains the same for others
                            paidCustomerNumber: customerNumber,
                            amount: inputValue
                        };
                    saveLogEvent({
                        logLevel: "error",
                        status: "failure",
                        message: {
                            customerNumber: customerId,
                            bankRRN: data.data[0].BankRRN,
                            amount: data.data[0].PayerAmount,
                            TxnStatus: "Failure",
                            ...logMessage,
                        },
                        payload: {
                            trigger: logMessage.trigger,
                            Page: logMessage.Page,
                        }
                    })
                }
                else {
                    throw new Error('Payment not completed');
                }
            }
            else {
                setTimeout(checkPaymentStatus, 1000);
                setTimeout(() => {
                    window.location.href = '/'; // Redirect to homepage after 5 minutes
                }, 300000);
            }

        }

        catch (error) {
            console.log("error :", error)
            setTimeout(checkPaymentStatus, 1000);
        }
    };

    if (isLoading) {
        return (
            <div className="p-4 mt-[30%] border-2 border-gray-300 rounded-lg text-center">
                <div className="text-lg font-bold">{labels.processing}</div>
                <div>{labels.pleaseWait}</div>
            </div>
        );
    }

    if (paymentSuccessful) {
        return (
            <div className="p-4 mt-[30%] border-2 border-gray-300 rounded-lg text-center">
                <div className="text-lg font-bold">{labels.paymentSuccessful}</div>
                <div>{labels.thankYouMessage}</div>
                <div className="mt-4">
                    <div>{labels.payerAmount}: {payAmount}</div>
                    <div>{labels.bankRrn}: {bankRRN}</div>
                    <div>{labels.transactionDate}: {formatCurrentDate()}</div>
                </div>
                <button
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg"
                    onClick={() => navigate('/')}
                >
                    OK
                </button>
            </div>
        );
    }

    if (paymentFailure) {
        return (
            <div className="p-4 mt-[30%] border-2 border-gray-300 rounded-lg text-center">
                <div className="text-lg font-bold">{labels.paymentFailure}</div>
                {/* <div>{labels.thankYouMessage}</div> */}
                <button
                    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg"
                    onClick={() => navigate('/')}
                >
                    OK
                </button>
            </div>
        );
    }
console.log(groupNumber)
    return (
        <>
            <div className="font-bold mt-2 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-lg fs-32w">{labels.ready}</div>
            <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
               {
                (groupNumber ||selectedCustomers) && <div className="flex justify-around space-x-2 mb-4 overflow-x-auto max-w-[100%] w-fit mx-auto no-scrollbar">
                {customerThumbnails?.map((customer, index) => (
                    <div key={index} className="flex flex-col items-center">
                        <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-green-500 flex-shrink-0">
                            <img src={customer.thumbnail} alt="Customer" className="w-full h-full object-cover" />
                        </div>
                        <span className="text-xs mt-1 text-center">{customer.number}</span>
                    </div>
                ))}
            </div>
               }
                <div className="grid grid-cols-2 gap-2">
                    <div>{groupNumber ? labels.GroupName : labels.customerName}</div>
                    <div className="text-end">{groupNumber ? gpName : customerInfo?.Name}</div>
                    <div>{groupNumber ? labels.GroupId : labels.customerNumber}</div>
                    <div className="justify-self-end">{groupNumber ? gpNumber : customerInfo?.Number}</div>
                    <div className=''>{labels.amountOfPayment}</div>
                    <div className="justify-self-end text-lg">
                        {groupNumber ||selectedCustomers? formatIndianCurrency(totalAmount) : formatIndianCurrency(inputValue)}
                    </div>
                </div>
                {(!groupNumber && !selectedCustomers)&& <div className="flex justify-center mt-2">
                    <div className="w-[150px] h-[150px] bg-gray-300 overflow-hidden">
                        <img src={thumbnail} alt={thumbnail} className="w-full h-full object-cover" />
                    </div>
                </div>}
                <div className="flex justify-center">
                    <button onClick={redirectToPaymentPage} className="mt-4 text-green-900 px-4 py-2 rounded-lg text-lg" style={{ backgroundColor: "#fdba14" }}>{labels.payFromPhone}</button>
                </div>
            </div>
            <div className='px-4 py-4 mt-2 border-2 border-gray-300 mx-auto rounded-lg fs-30w'>
                <div className='text-center text-lg'>{labels.payByQrCode}</div>
                <div className="w-fit h-fit bg-gray mt-6 overflow-hidden mx-auto">
                    <QRCode className="w-[100%] h-[100%]" value={url} />
                </div>
                <div className="flex justify-center">
                    <button onClick={copyUrlToClipboard} className="mt-12 text-black px-6 py-2 rounded-lg font-semibold bg-[#6A1B9A]" style={{ backgroundColor: "#fdba14" }}>{labels.copyAndShare}</button>
                </div>
            </div>
        </>
    );
};

export default observer(Confirmations);
